import {useEffect, useState} from 'react';

/** Set on `<html>` while a PDP configuration overlay is open (option picker, config panel, cover flyout). */
export const PDP_CONFIG_OVERLAY_OPEN_CLASS = 'pdp-config-overlay-open';

export function setPdpConfigOverlayDocumentOpen(isOpen) {
  if (typeof document === 'undefined') return;

  document.documentElement.classList.toggle(PDP_CONFIG_OVERLAY_OPEN_CLASS, Boolean(isOpen));
}

/**
 * Tracks PDP configuration overlay open state via `html.pdp-config-overlay-open`.
 * Used to lower z-index of global overlays (e.g. showroom selection popup) below option panels.
 */
export function usePdpConfigOverlayOpen() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const root = document.documentElement;

    const sync = () => {
      setIsOpen(root.classList.contains(PDP_CONFIG_OVERLAY_OPEN_CLASS));
    };

    sync();

    const observer = new MutationObserver(sync);
    observer.observe(root, {attributes: true, attributeFilter: ['class']});

    return () => observer.disconnect();
  }, []);

  return isOpen;
}
